import { authorizedFetch } from './session';

export interface DailyStartResponse {
  sessionId: string;
  challengeDate: string;
  targetMs: number;
  attempts: number;
}

export interface DailyStopResponse {
  elapsedMs: number | null;
  errorMs: number;
  isFalseStart: boolean;
  attemptsCompleted: number;
  totalErrorMs: number | null;
}

export interface DailySubmitResponse {
  ok: true;
  displayName: string;
  totalErrorMs: number;
}

export interface DailyLeaderboardRow {
  rank: number;
  displayName: string;
  totalErrorMs: number;
  submittedAt: number;
}

export interface DailyLeaderboardResponse {
  challengeDate: string;
  targetMs: number;
  leaderboard: DailyLeaderboardRow[];
}

/** Works signed out too — `authorizedFetch` only attaches a session token when one exists, never requires it. */
export function startDailyChallenge(): Promise<DailyStartResponse> {
  return authorizedFetch<DailyStartResponse>('/api/daily/start', { method: 'POST' });
}

export function armDailyAttempt(sessionId: string, attemptIndex: number): Promise<{ ok: true }> {
  return authorizedFetch('/api/daily/arm', { method: 'POST', body: JSON.stringify({ sessionId, attemptIndex }) });
}

export function stopDailyAttempt(
  sessionId: string,
  attemptIndex: number,
  elapsedMs: number | null,
  isFalseStart: boolean,
): Promise<DailyStopResponse> {
  return authorizedFetch<DailyStopResponse>('/api/daily/stop', {
    method: 'POST',
    body: JSON.stringify({ sessionId, attemptIndex, elapsedMs, isFalseStart }),
  });
}

/** `displayName` is ignored server-side for a signed-in caller — their real username is used instead. */
export function submitDailyChallenge(sessionId: string, displayName?: string): Promise<DailySubmitResponse> {
  return authorizedFetch<DailySubmitResponse>('/api/daily/submit', {
    method: 'POST',
    body: JSON.stringify({ sessionId, displayName }),
  });
}

export function fetchDailyLeaderboard(date?: string): Promise<DailyLeaderboardResponse> {
  return authorizedFetch<DailyLeaderboardResponse>(`/api/daily/leaderboard${date ? `?date=${date}` : ''}`);
}
